function assert(condition: unknown, message?: string): asserts condition {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!condition) throw new Error(message ?? 'Assertion failed!');
}

export default assert;
